// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"324016ff","85":"793bc7ff","112":"2c0dfb22","260":"f75eb2a1","423":"095c0bbd","453":"02b75004","455":"5ec90855","494":"50ee193b","833":"ada5ce90","914":"65fd9e2b","931":"83cfb8c4","984":"1321b24c"}[chunkId] + ".chunk.js";
};